import 'reflect-metadata';

// Constants
export const JSONPROPERTY__METADATA_KEY = "jsonProperty";
export type METADATA_SERIALIZE_TYPES = 'date' | 'datetime' | 'datetime-specific';

/**
 * The metadata interfaces
 */
export interface IJsonMetaData<T> {

    // The JSON object property name to use for deserialization
    name?: string;
    // The Typescript class to deserialize to
    toClass?: { new(): T };
    // For properties that need special deserialization (dates for now)
    toType?: METADATA_SERIALIZE_TYPES;
    // For serializing based on enum
    enumMapper?: any;
    // Type to map against
    enumProp?: string;
    // The primitive
    designType?: string;    

}

/**
 * Decorator for a variety of metadata options
 * @param metadata The metadata object of possible information
 */
export function JsonProperty<T>(metadata?: IJsonMetaData<T> | string): any {

    if (metadata instanceof String || typeof metadata === "string") {
        return Reflect.metadata(JSONPROPERTY__METADATA_KEY, {
            name        : metadata,
            toClass     : undefined,
            toType      : undefined,
            designType  : undefined,
            enumMapper  : undefined,
            enumProp    : undefined 
        });
    }
    else {
        const metadataObj = metadata as IJsonMetaData<T>;
        return Reflect.metadata(JSONPROPERTY__METADATA_KEY, {
            name        : metadataObj ? metadataObj.name : undefined,
            toClass     : metadataObj ? metadataObj.toClass : undefined,
            toType      : metadataObj ? metadataObj.toType : undefined,
            designType  : metadataObj ? metadataObj.designType : undefined,
            enumMapper  : metadataObj ? metadataObj.enumMapper : undefined,
            enumProp    : metadataObj ? metadataObj.enumProp : undefined
        });
    }

}